import React, { Fragment, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ErrorBoundary, useModulePermission } from '@bechtel/client-common';
import { ReportsDetail } from './detail';
import { ReportsList } from './list';
import { useReportPermissions } from './hooks';
import { Alert } from '@bechtel/gds';
import { Trans } from '@lingui/macro';

const Reports = () => {
  const { canViewReportsModule } = useModulePermission();
  const { canViewReports } = useReportPermissions();
  const [isListCollapsed, setIsListCollapsed] = useState(false);
  if (!canViewReportsModule) {
    return (
      <Alert>
        <Trans>Sorry, Report module is not activated for this project.</Trans>
      </Alert>
    );
  }
  if (!canViewReports)
    return (
      <Alert>
        <Trans>Sorry, you do not have permission to view reports</Trans>
      </Alert>
    );
  const handleToggleCollapse = () => {
    setIsListCollapsed((state) => !state);
  };
  return (
    <Fragment>
      <ErrorBoundary>
        <Routes>
          <Route path=":id/*" element={<ReportsDetail isListCollapsed={isListCollapsed} />}></Route>
          <Route path="*" element={<ReportsDetail isListCollapsed={isListCollapsed} />} />
        </Routes>
      </ErrorBoundary>
      <ErrorBoundary>
        <ReportsList isListCollapsed={isListCollapsed} onToggleCollapse={handleToggleCollapse} />
      </ErrorBoundary>
    </Fragment>
  );
};

export default Reports;
